import { get } from 'lodash'

export const getProfile = (domainID, profiles) => {
  const profile = profiles.find((data) => data?.website_id === domainID)
  const defaultProfile = get(profiles, '[0]', {})
  return profile?.id ? profile : defaultProfile
}
